export default __webpack_public_path__ + "fonts/Nunito-Regular.8ad2c677.woff2";